<template>
    <div
        :class="`formulate-input-element formulate-input-element--${context.class}`"
        :data-type="context.type"
    >
        <Dropdown 
            :value="selectedVendorObj" 
            :options="options" 
            optionLabel="name" 
            dataKey="id" 
            :filter="true" 
            :placeholder="placeholder" 
            :showClear="true"
            class="w-100"
            v-bind="context.attributes"
            @input="handleSelection"
            @before-show="onBeforeShow"
            @hide="context.blurHandler"
        >   <!-- optionValue="id" - up/down arrows did not work when using optionValue -- it screws up what is shown in value slot I think -->
            <template #indicator>
                <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>  <!-- had to add this slot, even though it has default -->
            </template>
            <template #value="slotProps">
                <transition name="fade-fast" mode="out-in">
                <div v-if="slotProps.value" class="">{{ slotProps.value.name }}</div>
                <span v-else-if="loadingOptions" class="text-muted">
                    <b-spinner small class="text-muted mr-1"></b-spinner>
                    <!-- <i class="pi pi-spin pi-spinner" /> -->
                    Loading...
                </span>
                <span v-else>
                    {{slotProps.placeholder}}
                </span>
                </transition>
            </template>
            <template #option="slotProps">
                <div v-if="loadingOptions" key="loadingVendorList">
                    <b-spinner small class="text-muted mr-1"></b-spinner>
                    Loading...
                </div>
                <div v-else key="vendorListLoaded" class="supplier-options-item">
                    <div>{{slotProps.option.name}}</div>
                </div>
            </template>
        </Dropdown>
    </div>
</template>

<script>
import { errorHandling } from '../../js/custom-vue-mixins';
import { suppliosApi } from '../../js/api-service';
import Dropdown from 'primevue/dropdown';

// formulate custom inputs:  must read from and write to context.model
// for this one, we'll assume that is only the ID of the company/vendor
// then we need to get options as needed, from here
// no options passed in from parent?  or have a prop set to fetch companies vs. get from prop?

export default {
    name: 'FormulateVendorSelect',
    components: {
        Dropdown,
    },
    mixins: [
        errorHandling,
    ],
    props: {
        context: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            loadingOptions: false,
            selectedVendorId: '',
            //selectedVendorObj: null,
            fetchedOptions: null,  // we fetch when user clicks on dropdown - use null until we know we've fetched them
        }
    },
    computed: {
        localModel() {
            return this.context.model;
        },
        options() {
            // warning... if you set 'classification' to something that does not have options prop, then context.options = false
            return this.fetchedOptions ?? [{id: 'LOADING'}];  // should be array of option objects - need to transform/rekey?
        },
        optionsMap() {  // options keyed by ID
            return Object.fromEntries(this.options.map(opt => ([opt.id, opt])));
        },
        selectedVendorObj() {
            return this.optionsMap[this.selectedVendorId] ?? null;
        },
        readOnly() {
            // this is for later... for showing in complete read-only mode
            return this.context.attributes?.disabled ?? false;
        },
        placeholder() {
            return this.context.attributes?.placeholder ?? 'Select a Vendor...';
        }
    },
    mounted() {
        // do we already have a selected value?  if not an object, just the ID, then we need to get options now
        // TODO - if in READ ONLY mode, then you may not want to get the whole list 
        //      (because you might have vendors looking at in, like in a workflow)
        //      in that case, you may want to just do a retrieve() instead of list() from API
        const currentPropValue = this.context.model;
        if (currentPropValue && typeof currentPropValue == 'string') {
            this.selectedVendorId = currentPropValue;
            this.getVendorOptions();
        }
    },
    methods: {
        onBeforeShow() {
            // if we havne't fetched options yet, then do it now
            if (!this.fetchedOptions) {
                this.getVendorOptions();
            }
        },
        async getVendorOptions() {
            this.loadingOptions = true;
            try {
                //const { data } = await suppliosApi.vendorStandard.list();
                //const { results } = data;
                //this.fetchedOptions = results ? [ ...results ] : [];  // its paginated.... - default to empty list so we know we've fetched once
                const { data } = await suppliosApi.vendorStandard.list_options();
                this.fetchedOptions = data;  // list_options is a flat list with ONLY { id, name }
            } catch (err) {
                this.apiErrorHandler(err);
            }
            this.loadingOptions = false;
        },
        handleSelection(vendor) {
            // if we have optionValue="id" then this will be the ID string -- otherwise will be the full object
            let selectedId = '';  // vendorObj will be null if we 'clear' the selection - so use this unless we have something
            if (vendor) {
                selectedId = typeof vendor == 'string' ? vendor : vendor.id;
            }
            this.selectedVendorId = selectedId;
            this.context.model = selectedId;
        }
    }
}
</script>

<style>

</style>